'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var handleChange = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(event, allowedValues, defaultValue) {
    var valueFromEvent, paginateBy;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            valueFromEvent = Number(event.target.value);
            paginateBy = allowedValues.includes(valueFromEvent) ? valueFromEvent : defaultValue;
            _context.next = 4;
            return updateCartPagination(paginateBy);

          case 4:

            window.location.reload();

          case 5:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function handleChange(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

exports.init = init;

var _functional = require('../utils/functional');

var _helpers = require('./_helpers');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var defaultValue = 12;
var allowedValues = [6, 12, 18, 24, 30, 36, 42, 48];

function updateCartPagination(paginateBy) {
  return (0, _functional.fetchJSON)('/cart/update.js', (0, _assign2.default)({}, (0, _functional.getDefaultRequestConfig)(), {
    method: 'POST',
    body: (0, _stringify2.default)({
      attributes: {
        pagination: paginateBy
      }
    })
  }));
}

function init(_ref2) {
  var el = _ref2.el,
      context = _ref2.context;

  var selectors = (0, _helpers.createSelectors)({
    selectors: {
      select: 'Select'
    },
    context: context
  });
  var els = {
    el: el,
    select: context.getElement(selectors.select)
  };

  var changeEvent = function changeEvent(event) {
    return handleChange(event, allowedValues, defaultValue);
  };

  els.select.addEventListener('change', changeEvent);
}